import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Center, TextInput, TextLinkButton, RichTextEditor, getSize, PrimaryButton, SecondaryButton } from '@lib/common';
import { Form, Space } from 'antd';
import styled from 'styled-components';
import { DeleteOutlined } from '@ant-design/icons';
import { useCallback, useEffect, useMemo, useRef } from 'react';
import { useForm } from 'antd/lib/form/Form';
import { RequestStatus } from '@module/form';
import { Size } from '@module/file-storage';
import { StyledLine, StyledSection, StyledSectionWrapper, StyledSpaceContainer, StyledTag } from './section.component';
import { AudioFileEdit, AudioFileContainerDirection } from '../audio-file';
import { useTranslation } from 'next-i18next';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var StyledSectionTileContainer = styled.div.withConfig({
  displayName: "section-editcomponent__StyledSectionTileContainer",
  componentId: "sc-sai323-0"
})(["display:flex;min-height:", ";padding:", " ", " ", " ", ";"], getSize('padding64'), getSize('padding8'), getSize('padding0'), getSize('padding16'), getSize('padding0'));
var TitleArea = styled.div.withConfig({
  displayName: "section-editcomponent__TitleArea",
  componentId: "sc-sai323-1"
})(["flex:1;"]);
var DeleteArea = styled.div.withConfig({
  displayName: "section-editcomponent__DeleteArea",
  componentId: "sc-sai323-2"
})(["display:flex;align-items:center;"]);
var TitleInput = styled(TextInput).withConfig({
  displayName: "section-editcomponent__TitleInput",
  componentId: "sc-sai323-3"
})(["font-weight:700;font-size:", ";padding:", ";"], getSize('typo24'), getSize('padding0'));
var StyledGroupButton = styled(Space).withConfig({
  displayName: "section-editcomponent__StyledGroupButton",
  componentId: "sc-sai323-4"
})(["display:flex;flex-direction:row-reverse;"]);
export var SectionEditComponent = function SectionEditComponent(_ref) {
  var section = _ref.section,
      isOnlyRemainingSection = _ref.isOnlyRemainingSection,
      onDeleteSection = _ref.onDeleteSection,
      onUpdateSection = _ref.onUpdateSection,
      onSaveSection = _ref.onSaveSection,
      onCancel = _ref.onCancel,
      sectionIndex = _ref.sectionIndex,
      addSectionFileStatus = _ref.addSectionFileStatus,
      file = _ref.file,
      onResetAddSectionFileUseCase = _ref.onResetAddSectionFileUseCase,
      onShowingUploadSectionFileModal = _ref.onShowingUploadSectionFileModal,
      sectionLabel = _ref.sectionLabel,
      onShowingUploadSectionAudioFileModal = _ref.onShowingUploadSectionAudioFileModal,
      onDeletingAudioFile = _ref.onDeletingAudioFile,
      saveSectionStatus = _ref.saveSectionStatus,
      editorLabels = _ref.editorLabels;

  var _useForm = useForm(),
      _useForm2 = _slicedToArray(_useForm, 1),
      form = _useForm2[0];

  var _useTranslation = useTranslation('common'),
      translation = _useTranslation.t;

  var richTextEditorRef = useRef(null);
  var audioFile = section === null || section === void 0 ? void 0 : section.audioFile;
  var audioLabel = {
    deleteTitle: translation('deleteConfirmation'),
    deleteOk: translation('yes'),
    deleteCancel: translation('no')
  };

  var handleSectionTitleFocus = function handleSectionTitleFocus(inputValue) {
    var defaultTitleText = "".concat(sectionLabel.defaultSectionTitle);
    var isDefaultTitleText = inputValue === defaultTitleText;

    if (isDefaultTitleText) {
      form.setFieldsValue({
        title: ''
      });
    }
  };

  var onFieldsChange = useCallback(function (e) {
    var _e = _slicedToArray(e, 1),
        infoChange = _e[0];

    if (!infoChange) return;
    var name = infoChange.name,
        value = infoChange.value;

    var _name = _slicedToArray(name, 1),
        field = _name[0];

    onUpdateSection(field, value);
  }, [onUpdateSection]);

  var handleSectionTitleBlur = function handleSectionTitleBlur(inputValue) {
    var isEmptyInputValue = !inputValue.length;

    if (isEmptyInputValue) {
      var defaultTitleText = "".concat(sectionLabel.defaultSectionTitle);
      form.setFieldsValue({
        title: defaultTitleText
      });
      onUpdateSection('title', defaultTitleText);
    }
  };

  var renderDeleteIcon = function renderDeleteIcon() {
    return !isOnlyRemainingSection && /*#__PURE__*/_jsx(DeleteArea, {
      children: /*#__PURE__*/_jsx(TextLinkButton, {
        onClick: onDeleteSection,
        icon: /*#__PURE__*/_jsx(DeleteOutlined, {
          onClick: function onClick(e) {
            e.stopPropagation();
            onDeleteSection();
          }
        })
      })
    });
  };

  var initialValues = useMemo(function () {
    return _objectSpread(_objectSpread({}, section), {}, {
      title: section.title,
      description: section.description
    });
  }, [section]);
  useEffect(function () {
    if (addSectionFileStatus === RequestStatus.SUCCESS && file && file.url) {
      richTextEditorRef.current.insertImageHandler(file.url);
      onResetAddSectionFileUseCase();
    }
  }, [addSectionFileStatus, file, onResetAddSectionFileUseCase]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(StyledSpaceContainer, {
      direction: "vertical",
      size: "middle",
      children: /*#__PURE__*/_jsx(StyledSectionWrapper, {
        form: form,
        name: "section",
        initialValues: initialValues,
        onFieldsChange: onFieldsChange,
        children: /*#__PURE__*/_jsxs(StyledSection, {
          $focus: true,
          children: [/*#__PURE__*/_jsx(StyledTag, {
            children: /*#__PURE__*/_jsxs(Center, {
              children: [sectionLabel.section, " ", sectionIndex]
            })
          }), /*#__PURE__*/_jsxs(StyledSectionTileContainer, {
            children: [/*#__PURE__*/_jsx(TitleArea, {
              children: /*#__PURE__*/_jsx(Form.Item, {
                name: "title",
                children: /*#__PURE__*/_jsx(TitleInput, {
                  onFocus: function onFocus(e) {
                    return handleSectionTitleFocus(e.target.value);
                  },
                  onBlur: function onBlur(e) {
                    return handleSectionTitleBlur(e.target.value);
                  },
                  placeholder: sectionLabel.placeholderSectionTitle,
                  bordered: false
                })
              })
            }), renderDeleteIcon()]
          }), /*#__PURE__*/_jsx(StyledLine, {}), audioFile && /*#__PURE__*/_jsx(AudioFileEdit, {
            source: audioFile.url,
            onEdit: onShowingUploadSectionAudioFileModal,
            fileName: '',
            fileSize: Size.format(audioFile.size),
            label: audioLabel,
            onDelete: onDeletingAudioFile,
            direction: AudioFileContainerDirection.HORIZONTAL
          }, audioFile.id.toString()), /*#__PURE__*/_jsx(Form.Item, {
            name: 'description',
            children: /*#__PURE__*/_jsx(RichTextEditor, {
              ref: richTextEditorRef,
              placeholder: sectionLabel.placeholderSectionDescription,
              content: section.description || sectionLabel.defaultSectionDescription,
              editorLabels: editorLabels,
              addImage: function addImage() {
                return onShowingUploadSectionFileModal(section.id.toString());
              },
              addAudio: onShowingUploadSectionAudioFileModal
            })
          }), /*#__PURE__*/_jsxs(StyledGroupButton, {
            children: [/*#__PURE__*/_jsx(SecondaryButton, {
              onClick: onCancel,
              children: sectionLabel.cancel
            }), /*#__PURE__*/_jsx(PrimaryButton, {
              onClick: onSaveSection,
              loading: saveSectionStatus === RequestStatus.EXECUTE,
              children: sectionLabel.save
            })]
          })]
        })
      })
    })
  });
};